module.exports = __webpack_public_path__ + "img/epicas.2cd9a3b7.png";